// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"330":"89e10a10","487":"24dff0be","557":"2c12aa1f","654":"5a8bca64","733":"e11057a3","822":"5778911a"}[chunkId] + ".chunk.js";
};